import { getComponentCssUrl, getGlobalCssUrl } from '../Global/loadDependency'

// Lazy template creation to avoid calling getCdnUrl at module load time
function createNavFooterLevel0Template() {
  const t = document.createElement('template')
  t.innerHTML = `
<link href="${getGlobalCssUrl()}" rel="stylesheet" />
<link href="${getComponentCssUrl('NavFooter-Level0--wc.css')}" rel="stylesheet" />
`
  return t;
}

const getTemplateNavFooterLevel0Styles = () => createNavFooterLevel0Template();
export { getTemplateNavFooterLevel0Styles };
